import React, { FC } from 'react'
import { MostViewedProps } from './MostViewed.props'
import styles from './MostViewed.module.scss'
import MostViewedItem from '../MostViewedItem/MostViewedItem'

const MostViewed: FC<MostViewedProps> = ({ title, mostViewedProjects, isSpace }) => (
  <div>
    <h3 className={styles.title}>Most Viewed Projects in {title}</h3>
    <div>
      <div className={styles.header}>
        <div className={styles.artist}>
          <div className={styles.column}>Artist/Project</div>
        </div>
        <div className={styles.label}>
          {isSpace ? <div className={styles.column}>Zone</div> : null}
        </div>
        <div className={styles.follow}></div>
      </div>
      {mostViewedProjects.map((item) => (
        <MostViewedItem key={item.campaign.id} campaign={item.campaign} />
      ))}
    </div>
  </div>
)

export default MostViewed
